<template>
  <div
    class="definition-bracket"
    :class="classes"
    :draggable="isDraggable"
    @dragstart="dragStartHandler"
    @dragover="dragOverHandler"
    @dragleave="dragLeaveHandler"
    @drop="dropHandler"
    @dragend="dragEndHandler"
  >
    <svg-icon
      :icon="icon"
      :key="attribute.definitionId"
      @click.native="select(attribute)"
    ></svg-icon>
    <span class="definition-bracket__count-group" v-if="showMustMatch" @dblclick="clickHandler">{{ attribute.mustMatch }}</span>
  </div>
</template>

<script>
import SvgIcon from '@/components/common/svgIcon'
import leftParenthesisSquare from '@/assets/svg/left-bracket.svg'
import rightParenthesisSquare from '@/assets/svg/right-bracket.svg'
import leftParenthesis from '@/assets/svg/left-parenthesis.svg'
import rightParenthesis from '@/assets/svg/right-parenthesis.svg'
import SelectableMixin from './SelectableMixin'
import DragAndDropHandlers from '../mixins/DragAndDropHandlers'
import { definitionPartTypes } from '../../store/mutations'
import { createPopover, popoverTypes } from '@/components/common/popover'
import { CREATE_COUNT_GROUP } from '@/appComponents/workbench/targetDefinition/store/actions'
// import HoverOver from '../mixins/HoverOver'

const DIRECTION = {
  left: 0,
  right: 1 << 0
}

const BRACKET_TYPE = {
  square: 1 << 1,
  normal: 1 << 2
}

const BRACKET_MAP = {
  [DIRECTION.left | BRACKET_TYPE.square]: leftParenthesisSquare,
  [DIRECTION.right | BRACKET_TYPE.square]: rightParenthesisSquare,
  [DIRECTION.left | BRACKET_TYPE.normal]: leftParenthesis,
  [DIRECTION.right | BRACKET_TYPE.normal]: rightParenthesis
}

export default {
  DIRECTION,
  BRACKET_TYPE,
  mixins: [
    SelectableMixin,
    DragAndDropHandlers
  ],
  components: {
    SvgIcon
  },
  props: {
    direction: {
      type: Number,
      required: true
    },
    bracketType: {
      type: Number,
      default: BRACKET_TYPE.normal
    },
    level: {
      type: Number,
      default: 0
    },
    definitionId: {
      type: String
    },
    attribute: {
      type: Object
    }
  },
  computed: {
    icon () {
      return BRACKET_MAP[this.direction | this.bracketType]
    },
    isCountGroup () {
      return !!this.attribute.mustMatch
    },
    showMustMatch () {
      return (this.isCountGroup && this.direction === 0)
    },
    classes () {
      return [
        {
          'definition-bracket--left': this.direction === DIRECTION.left,
          'definition-bracket--right': this.direction === DIRECTION.right,
          'selected': this.isSelected,
          'definition-bracket--square': this.bracketType === BRACKET_TYPE.square,
          'cant-drop-here': !this.canDropHere
        },
        this.levelClass()
      ]
    },
    defType () {
      return this.direction === 0 ? definitionPartTypes.GROUP_BEGINNING : definitionPartTypes.GROUP_ENDING
    },
    hoverOverMessage () {
      return 'Grouping-UE : ' + '1234223'
    }
  },
  methods: {
    levelClass () {
      return `level-${this.level}`
    },
    clickHandler (e) {
      if (!this.disabled) {
        this.popover = createPopover({
          direction: 'top',
          attribute: this.attribute,
          parent: e.target,
          root: document.getElementById('app'),
          type: popoverTypes.COUNT_GROUP
        })
        this.popover.$on('select', mustMatch => {
          const details = {
            groupId: this.attribute.definitionId,
            mustMatch
          }
          this.$store.dispatch('workbench/' + CREATE_COUNT_GROUP, details)
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .definition-bracket {
    height: rem(32) !important;
    position: relative;
    cursor: pointer;
    display: flex;

    svg {
      width: rem(21) !important;
      height: rem(32) !important;
      fill: color(target, level-1);
    }

    &.cursor-left:before {
      top: 4px;
    }

    &:hover {
      svg {
        fill: color(target, level-1-light);
      }
    }

    &.level-2 {
      svg {
        fill: color(target, level-2);
      }

      &:hover {
        svg {
          fill: color(target, level-2-light);
        }
      }
    }

    &.selected {
      svg {
        fill: color(yellow);
      }
    }

    &--left {
      margin-right: rem(-3);
    }

    &--right {
      margin-left: rem(-3);
    }

    &__count-group {
      display: inline-block;
      position: relative;
      top: rem(1);
      border-top-left-radius: rem(15px);
      border-bottom-left-radius: rem(15px);
      background: color(target, level-1-light);
      width: rem(30);
      height: rem(30);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: rem(-5);
      margin-right: rem(-6);
      border-right: rem(12) solid color(target, level-1-light);

      .level-2 & {
        border-right-color: color(target, level-2-light);
        background: color(target, level-2-light);
      }
    }
  }
</style>




// WEBPACK FOOTER //
// DefinitionBracket.vue?2f540882